export const NUMBER_VALIDATION_REGEX = '^(?:[1-9][0-9]*|0)$'
